import { render, staticRenderFns } from "./StaffingVariable.vue?vue&type=template&id=4d9edb4a&"
import script from "./StaffingVariable.vue?vue&type=script&lang=js&"
export * from "./StaffingVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports